export const getOfficialWindowPolicy = ({
  ticketChannel,
  ticketStatus,
  officialWindow = {},
  privateMessage = false,
  privateMessageInputVisible = false,
}) => {
  const isOfficial = ticketChannel === "whatsapp_oficial";
  const isPending = ticketStatus === "pending";
  const isInternalSend = isPending || privateMessage;
  const windowReady =
    officialWindow.applicable === true && officialWindow.loading !== true;
  const windowClosed =
    isOfficial &&
    !isInternalSend &&
    windowReady &&
    officialWindow.open === false;
  const windowUnavailable =
    isOfficial && !isInternalSend && !windowReady;
  const manualContinuationAvailable =
    officialWindow.manualContinuationAvailable === true;

  let blockedReason = "";
  if (windowUnavailable) {
    blockedReason = officialWindow.loading
      ? "Aguarde a verificação da janela de 24 horas antes de enviar."
      : "Não foi possível verificar a janela de 24 horas. Atualize a conversa e tente novamente.";
  } else if (windowClosed) {
    blockedReason = manualContinuationAvailable
      ? "A janela de 24 horas está encerrada. Envie um template aprovado ou continue manualmente pelo WhatsApp Web."
      : "A janela de 24 horas está encerrada. Envie um template aprovado por esta conexão.";
  }

  const showClosedWindowNotice =
    windowClosed && !privateMessageInputVisible && !isPending;

  return {
    canSendFreeForm:
      !isOfficial ||
      isInternalSend ||
      (windowReady && officialWindow.open === true),
    blockedReason,
    showClosedWindowNotice,
    showTemplateAction: showClosedWindowNotice,
    showManualContinuationAction:
      showClosedWindowNotice && manualContinuationAvailable,
    guidance: manualContinuationAvailable
      ? "Use um template aprovado ou prepare a mensagem para envio manual no WhatsApp Web."
      : "Use um template aprovado para iniciar uma nova conversa por esta conexão.",
  };
};

export const shouldRefreshOfficialWindow = ({
  data,
  ticketId,
  whatsappId,
  contactId,
}) => {
  if (
    data?.action !== "create" ||
    data?.message?.fromMe !== false
  ) {
    return false;
  }

  const eventTicket = data?.ticket || data?.message?.ticket;
  const eventTicketId =
    eventTicket?.id ?? data?.message?.ticketId;
  if (Number(eventTicketId) === Number(ticketId)) {
    return true;
  }

  if (
    !eventTicket ||
    !whatsappId ||
    !contactId
  ) {
    return false;
  }

  return (
    Number(eventTicket.whatsappId) === Number(whatsappId) &&
    Number(eventTicket.contactId) === Number(contactId)
  );
};

export default getOfficialWindowPolicy;
